import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Toaster } from "sonner";
import DashboardShell from "../../components/layout/DashboardShell";
import { EmptyState, Pill, Button } from "../../components/common/Primitives";
import { XCircle } from "lucide-react";
import api from "../../lib/api";
import RejectionReasonModal from "../../components/RejectionReasonModal";
import LogAsInvestmentButton from "../../components/investor/LogAsInvestmentButton";

export default function InvestorDealRooms() {
  const [rows, setRows] = useState([]);
  const [rejecting, setRejecting] = useState(null);
  const load = () => api.get("/investor/deal-rooms").then((r) => setRows(r.data || []));
  useEffect(() => { load(); }, []);
  return (
    <DashboardShell title="Deal Rooms" subtitle="INVESTOR · ACTIVE DEALS">
      <Toaster richColors position="top-right" />
      {rows.length === 0 ? (
        <EmptyState title="No deal rooms yet" hint="Deal rooms open after serious interest and admin facilitation." />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {rows.map((r) => (
            <div key={r.deal_room_id} className="border border-white/10 bg-white/70 backdrop-blur p-5 hover:border-gold/40 transition-colors" data-testid={`dr-card-${r.deal_room_id}`}>
              <div className="flex justify-between items-start">
                <div className="min-w-0 flex-1">
                  <div className="font-heading text-ink text-lg truncate">
                    {r.startup_name || "Deal Room"}
                  </div>
                  <div className="text-xs text-ink-muted font-mono mt-1">
                    {r.sector ? `${r.sector} · ` : ""}{r.deal_room_id}
                  </div>
                </div>
                <Pill tone="gold">{r.stage}</Pill>
              </div>
              <div className="mt-4 flex items-center justify-between flex-wrap gap-2">
                <Link to={`/deal-room/${r.deal_room_id}`} className="text-gold text-xs font-heading">Open →</Link>
                <div className="flex items-center gap-2">
                  <LogAsInvestmentButton room={r} onLogged={load} variant="compact" />
                  <Button
                    variant="ghost"
                    onClick={(e) => { e.preventDefault(); setRejecting(r); }}
                    data-testid={`dr-exit-${r.deal_room_id}`}
                    title="Exit deal room with feedback"
                  >
                    <XCircle size={12} className="inline mr-1 text-rose-600" /> Exit
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <RejectionReasonModal
        open={!!rejecting}
        onClose={() => setRejecting(null)}
        context="deal_room"
        targetId={rejecting?.deal_room_id}
        startupId={rejecting?.startup_id}
        startupName={rejecting?.startup_name || "This deal room"}
        onSubmitted={() => { setRejecting(null); load(); }}
      />
    </DashboardShell>
  );
}
